/* imports */
import db from 'db'

/* action types */
export const types = {
	IS_LOADING: 'BUNDLE/IS_LOADING',
	FETCH_SUCCESS: 'BUNDLE/FETCH_SUCCESS',
	FETCH_ERROR: 'BUNDLE/FETCH_ERROR',

	UPDATE_SUCCESS: 'BUNDLE/UPDATE_SUCCESS',

	RESET_STATE: 'BUNDLE/RESET_STATE'
};

/* action creators */
export const actions = {
		resetBundleHandler: () => dispatch => dispatch({type: types.RESET_STATE}),

		fetchBundleById: bundleId => dispatch => {
			dispatch({type: types.IS_LOADING});

			db.fetchBundleById(bundleId).then(
				bundle => dispatch({type: types.FETCH_SUCCESS, bundle}),
				error => dispatch({type: types.FETCH_ERROR, error})
			);
		},

		handleBundleUpdate: bundle => dispatch => {
			db.onBundleUpdate(bundle, bundle => dispatch({type: types.UPDATE_SUCCESS, bundle}));
		},

		signOut: () => dispatch => db.signOut
};

/* initial state */
const initialState = {
	isLoading: false,
	error: null,
	bundle: null
};

/* reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case types.IS_LOADING:
			return { ...state, isLoading: true };

		case types.FETCH_ERROR:
			return {	...state, isLoading: false, error: action.error };

		case types.FETCH_SUCCESS:
			return { ...state, isLoading: false, bundle: action.bundle };

		case types.UPDATE_SUCCESS:
			return { ...state, isLoading: false, bundle: action.bundle };

		case types.RESET_STATE:
			return initialState;

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/components/bundle-memento/bundleHandlerRedux.jsx